<template>
    <main-sidebar :name="name" :title="$t('filters')">
        <div class="p-4">
            <div class="flex mb-1">
                <label for="">{{ $t('vendors') | capitalize }}</label>
            </div>
            <div class="flex mb-4">
                <v-select 
                label="name" 
                :filterable="false" 
                :options="options.vendors" 
                @search="onSearchVendors"
                v-model="filters.vendors" 
                class="w-full" 
                multiple></v-select>

            </div>
            <div class="flex mb-1">
                <label for="">{{ $t('clients') | capitalize }}</label>
            </div>
            <div class="flex mb-4">
                <v-select v-model="filters.clients" :options="options.clients" class="w-full"
                    :reduce="(item) => item.id" label="name" multiple />
            </div>
            <div class="flex mb-1">
                <label for="">{{ $t('departaments') | capitalize }}</label>
            </div>
            <div class="flex mb-4">
                <v-select v-model="filters.departaments" :options="options.departaments" class="w-full"
                    :reduce="(item) => item.id" label="name" multiple />
            </div>
            <div class="flex mb-1">
                <label for="">{{ $t('categories') | capitalize }}</label>
            </div>
            <div class="flex mb-4">
                <v-select v-model="filters.categories" :options="options.categories" class="w-full"
                    :reduce="(item) => item.id" label="name" multiple />
            </div>

        </div>
        <div slot="footer" class="mt-4">
            <vs-row vs-type="flex" vs-justify="flex-end">
                <vs-col vs-w="6" class="px-2">
                    <vs-button color="primary" type="border" @click="clear" class="w-full">
                        {{ $t('clear_filters') }}
                    </vs-button>
                </vs-col>
                <vs-col vs-w="6" class="px-2">
                    <vs-button color="primary" type="filled" @click="setFilter" class="w-full">
                        {{ $t('apply_filters') }}
                    </vs-button>
                </vs-col>
            </vs-row>
        </div>
    </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import InputDate from '@/components/custom/InputDate'
import request from '../request.js'
import debounce from 'lodash/debounce'

export default {
    components: {
        MainSidebar,
        'v-select': vSelect,
        InputDate,
    },
    computed: {
        isSidebarActive() {
            return this.$store.state.sidebar === this.name
        },
        isLoading() {
            return this.loading.clients ||
                this.loading.departaments ||
                this.loading.vendors ||
                this.loading.categories
        }
    },
    data: () => ({
        options: {
            vendors: [],
            clients: [],
            departaments: [],
            categories: []
        },
        filters: {
            vendors: [],
            clients: [],
            departaments: [],
            categories: []
        },
        loading: {
            clients: false,
            vendors: false,
            departaments: false,
            categories: false,
        },
    }),
    methods: {
        clear() {
            this.filters = Object.assign({}, {
                vendors: [],
                clients: [],
                departaments: [],
                categories: []
            })
        },
        close() {
            this.$store.dispatch('toggleSidebar', '')
        },
        init() {
            this.filters = { ...this.value }
        },
        setFilter() {
            this.$emit('input', this.filters)
            this.close()
            this.$emit('search')

        },
        getClients() {
            this.loading.clients = true
            request
                .getClients()
                .then((response) => {
                    this.options.clients = [...response.data]
                    this.loading.clients = false
                })
                .catch((error) => {
                    this.loading.clients = false
                    this.showValidationErrors(error)
                })
        },
        getDepartaments() {
            this.loading.departaments = true
            request
                .getDepartaments()
                .then((response) => {
                    this.options.departaments = [...response.data]
                    this.loading.departaments = false
                })
                .catch((error) => {
                    this.loading.departaments = false
                    this.showValidationErrors(error)
                })
        },
        getCategories() {
            this.loading.categories = true
            request
                .getCategories()
                .then((response) => {
                    this.options.categories = [...response.data]
                    this.loading.categories = false
                })
                .catch((error) => {
                    this.loading.categories = false
                    this.showValidationErrors(error)
                })
        },
        onSearchVendors(search, loading) {
            if (search.length > 3) {
                loading(true);
                this.getVendors(loading, search, this);
            }
        },
        getVendors: debounce((loading, search, vm) => {
            request
                .vendorSearch({ search: search })
                .then((res) => {
                    vm.options.vendors = [...res.data.vendors, ...vm.filters.vendors]
                    loading(false);
                })
                .catch((err) => {
                    vm.options.vendors = []
                    loading(false);
                })
        }),
    },
    mixins: [loading],
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    watch: {
        isLoading(val) {
            if (val) {
                this.openLoading(`loading-${this.name}-sidebar`)
            } else {
                this.closeLoading(`loading-${this.name}-sidebar`)
            }
        },
    },
    mounted() {
        this.getClients()
        this.getCategories()
        this.getDepartaments()
    }
}
</script>

<style></style>